var exports = {
  "UD": "ApplicationsTab.module__buttonContainer___TVJDZU",
  "v$": "ApplicationsTab.module__documentationLink___TVJDZU",
  "Qp": "ApplicationsTab.module__documentationIcon___TVJDZU",
  "qI": "ApplicationsTab.module__listContainer___TVJDZU",
  "DB": "ApplicationsTab.module__itemContainer___TVJDZU",
  "k0": "ApplicationsTab.module__itemButton___TVJDZU",
  "HS": "ApplicationsTab.module__itemLeft___TVJDZU",
  "vi": "ApplicationsTab.module__itemAvatar___TVJDZU",
  "KO": "ApplicationsTab.module__itemAvatarPlaceholder___TVJDZU",
  "c2": "ApplicationsTab.module__itemTextBlock___TVJDZU",
  "wH": "ApplicationsTab.module__itemTitleRow___TVJDZU",
  "TJ": "ApplicationsTab.module__itemName___TVJDZU",
  "Fg": "ApplicationsTab.module__itemMetaRow___TVJDZU",
  "v5": "ApplicationsTab.module__itemChevron___TVJDZU",
  "p$": "ApplicationsTab.module__emptyState___TVJDZU",
  "dc": "ApplicationsTab.module__spinnerContainer___TVJDZU",
};

module.exports = exports;
